import React from 'react';
import ExpertCard, { ExpertCardData } from '@/components/ui/ExpertCard';

interface ExpertGridProps {
  experts: ExpertCardData[];
}

export default function ExpertGrid({ experts }: ExpertGridProps) {
  if (experts.length === 0) {
    return (
      <div className="surface-elevated p-16 flex flex-col items-center gap-4 text-center">
        <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
          <span className="text-2xl text-muted-foreground">◆</span>
        </div>
        <div>
          <h3 className="font-heading text-lg text-foreground mb-1">No experts match your filters</h3>
          <p className="text-sm text-muted-foreground max-w-sm">
            Try broadening your domain selection, adjusting the rate range, or removing badge tier filters.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-5">
      {experts.map((expert) => (
        <ExpertCard
          key={`browse-card-${expert.id}`}
          expert={expert}
          href="/expert-profile-page"
        />
      ))}
    </div>
  );
}